import React, { useRef, useEffect } from 'react';
import { useLabels } from 'wsm-common-data';
import propTypes from 'prop-types';
import { isBrowser } from 'ws-scripts/modules/environment';
import './SharePanel.scss';
import { MOBILE, DESKTOP } from '../../utils/widgetInfoDefaults';

const SharePanel = ({
	accountInfo,
	deviceType,
	openModal,
	showFooter,
	hideFooter
}) => {
	const labels = useLabels();
	const submitButton = useRef(null);

	const handleScroll = () => {
		if (submitButton.current !== null) {
			const buttonYPos =
				submitButton.current.getBoundingClientRect().y +
				submitButton.current.getBoundingClientRect().height;
			if (buttonYPos > 0) {
				hideFooter();
			} else {
				showFooter();
			}
		}
	};

	const handleScrollDebounce =
		isBrowser && window._ ? window._.debounce(handleScroll, 100) : null;

	useEffect(() => {
		if (deviceType === DESKTOP) {
			window.addEventListener('scroll', handleScrollDebounce);
		}
		return () => {
			if (deviceType === DESKTOP) {
				window.removeEventListener('scroll', handleScrollDebounce);
			}
		};
	});

	if (!accountInfo) {
		return null;
	}

	const { name, dealerCode } = accountInfo;

	const shareCopy = labels
		.get('SHARE_YOUR_STORY_DESCRIPTION')
		.replace('$account.name', name);

	if (deviceType === MOBILE) {
		return (
			<div className="lp-share">
				<p className="lp-share-body mb-0 p-5 text-inverse">
					{shareCopy}
				</p>
				<a
					className="btn btn-default btn-block submit-story-btn"
					href={`https://www.subaru.com/content/subaru/en/love-promise/ddc-love-promisesubmissionform.html?dealerNumber=${dealerCode}`}
				>
					{labels.get('LOVE_PROMISE_SUBMIT_STORY')}
				</a>
			</div>
		);
	} else {
		return (
			<div className="lp-share">
				<p className="lp-share-body mb-0 p-5 text-inverse row col-xs-12">
					{shareCopy}
				</p>
				<button
					type="button"
					className="btn btn-default btn-block submit-story-btn row col-xs-12"
					ref={submitButton}
					onClick={openModal}
				>
					{labels.get('LOVE_PROMISE_SUBMIT_STORY')}
				</button>
			</div>
		);
	}
};

SharePanel.propTypes = {
	accountInfo: propTypes.shape({
		name: propTypes.string,
		dealerCode: propTypes.string
	}).isRequired,
	deviceType: propTypes.string.isRequired,
	openModal: propTypes.func.isRequired,
	showFooter: propTypes.func.isRequired,
	hideFooter: propTypes.func.isRequired
};

export default SharePanel;
